import React from 'react';
import { Link } from 'react-router-dom';
import { getTabName } from '../utils';

const Tabs = ({token, tables}) => {
  if (!token) {
    return null;
  }
  let tabFromUrl = getTabName();
  let activeTab = tabFromUrl ? tabFromUrl : 'home';
  
  return (
    <div className="container">
      <ul className="nav nav-tabs">

        <li key="home" className="nav-item">
          <Link to={'/'} className={activeTab == 'home' ? 'nav-link active tab-item' : 'nav-link tab-item'}>Home</Link>
        </li>

        {tables && tables.map((table) => (
          <li key={table.id} className="nav-item">
            <Link to={'/table/'+table.id+'/list'} className={activeTab == table.id ? 'nav-link active tab-item' : 'nav-link tab-item'}>{table.pluralLabel}</Link>
          </li>
          )
        )}
        
        <li key="sites" className="nav-item">
          <Link to={'/sites'} className={activeTab == 'sites' ? 'nav-link active tab-item' : 'nav-link tab-item'}>Sites</Link>
        </li>

      </ul>
    </div>
  );
};

export default Tabs;
